import { createSvgIcon } from '@mui/material';

export const QuestionMarkIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none">
    <circle cx="7.94995" cy="7.5" r="7" stroke="currentColor" />
    <path
      d="M5.90454 5.40124C7.26818 1.99208 12.7227 6.0833 7.95 8.12851"
      stroke="currentColor"
      stroke-linecap="round"
    />
    <circle cx="7.68498" cy="9.96354" r="0.416667" fill="currentColor" />
  </svg>,
  'QuestionMark',
);
